import { LocationCode } from "pwapi";

export const SET_USER_SELECTED_LOCATION_CODE =
  "@@ui/SET_USER_SELECTED_LOCATION_CODE";

export type LocationCodeState = { userSelectedLocationCode?: LocationCode };
export const initialState: LocationCodeState = {
  userSelectedLocationCode: undefined,
};

const reducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_USER_SELECTED_LOCATION_CODE:
      return {
        ...state,
        userSelectedLocationCode: action.payload,
      };
    default:
      return state;
  }
};
export default reducer;
